import { Component, OnInit } from '@angular/core';
import { AccountRegistrationService } from '../../../services/account-registration.service';
import { ActivatedRoute } from '@angular/router';
import { Constants, ICountry, ILookup } from 'common';

@Component({
  selector: 'acc-registration-prs-details',
  templateUrl: './prs-details.component.html',
  styleUrl: './prs-details.component.scss',
})
export class PrsDetailsComponent implements OnInit {
  countries: ICountry[];
  counties: ILookup[];

  showEuQuestions: boolean = false;

  get formPrsDetails() {
    return this.accountRegistrationService.formPrsDetails;
  }

  get formGeneralDetails() {
    return this.accountRegistrationService.formGeneralDetails;
  }

  constructor(private readonly accountRegistrationService: AccountRegistrationService, private route: ActivatedRoute) {}

  ngOnInit(): void {
    this.countries = this.route.snapshot.data.countries;
    this.counties = this.route.snapshot.data.counties;
    this.enableEuQuestions(false);
  }

  countryChanged(value: string) {
    if (value.toLowerCase() === Constants.irelandCountryString.toLocaleLowerCase()) {
      this.formPrsDetails.controls.county.enable();
      this.showEuQuestions = false;
      this.enableEuQuestions(false);
    } else {
      this.showEuQuestions = this.accountRegistrationService.countryIsEu(value.toLowerCase());
      this.enableEuQuestions(this.accountRegistrationService.countryIsEu(value.toLowerCase()));
      this.formPrsDetails.controls.county.setValue(null);
      this.formPrsDetails.controls.county.disable();
    }
  }

  private enableEuQuestions(enable: boolean) {
    if (enable) {
      this.formPrsDetails.controls.q1.enable();
      this.formPrsDetails.controls.q2.enable();
      this.formPrsDetails.controls.q3.enable();
    } else {
      this.formPrsDetails.controls.q1.disable();
      this.formPrsDetails.controls.q2.disable();
      this.formPrsDetails.controls.q3.disable();
    }
  }

  copyGeneralToPrs() {
    this.accountRegistrationService.copyGeneralToPrs();
    this.countryChanged(this.formPrsDetails.controls.country.value);
  }
}
